import React from 'react';
import styles from './SocialLinks.module.css';

function SocialLinks() {
  return (
    <div className={styles.socialLinks}>
      <h3>Follow Us</h3>
      <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className={styles.facebook}>Facebook</a>
      <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className={styles.tiktok}>TikTok</a>
      <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className={styles.instagram}>Instagram</a>
    </div>
  );
}

export default SocialLinks;
